import { Provider } from 'mobx-react';
import React, { Component } from 'react';
import { GlobalStyles } from './app.styles';
import { AppRouter } from './router';
import { RootStore } from './stores';
import { AiExtensionConnectionBootstrap } from '@enter/core';

class App extends Component {
    public render(): React.ReactElement {
        return (
            <>
                <GlobalStyles />
                <Provider rootStore={new RootStore()}>
                    <AiExtensionConnectionBootstrap />
                    <AppRouter />
                </Provider>
            </>
        );
    }
}

export default App;
